import React, { useEffect, useState } from "react";
import roleService from "../Services/roleService";
import { useLocation, useNavigate } from "react-router-dom";
import SupplierService from "../Services/supplierService";
import toast from "react-hot-toast";
import PayableService from "../Services/payableService";
import RoleService from "../Services/roleService";
import Loading from "../Modals/Loading";
import SecondaryButton from "../Components/SecondaryButton";
import { FiPlus } from "react-icons/fi";

const AddRole = ({ edit = false }) => {
  const [loading, setLoading] = useState(false);
  const [ID, setID] = useState();
  const [data, setData] = useState({
    name: "",
  });
  const [errors, setErrors] = useState({
    name: false,
  });
  const [regex, setRegex] = useState({
    name: /.{1,50}$/,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    if (edit) {
      if (params.get("id")) {
        setLoading(true);
        roleService.getSingle(params.get("id")).then((res) => {
          setData((d) => ({ ...d, name: res.role.name }));
          setID(res.role.id);
          setLoading(false);
        });
      }
    }
  }, []);

  const handleChange = (e) => {
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));
    setErrors((errs) => ({ ...errs, [e.target.name]: false }));
  };

  const submit = () => {
    setLoading(true);
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        console.log(v);
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill all the required fields");
      setLoading(false);
    } else {
      if (!edit) {
        RoleService.create(data).then((res) => {
          navigate("/roles");

          console.log("Roles not working properly..");

          setLoading(false);
        });
      } else {
        roleService
          .update(ID, data)
          .then((res) => {
            navigate("/roles");
            toast.success("Role updated successfully");
            setLoading(false);
          })
          .catch((err) => {
            toast.error("Error updating role");
            setLoading(false);
          });
      }
    }
  };

  return (
    <>
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <main className="mx-10 mt-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
          <p className="font-bold text-3xl text-secondary text-center mt-10">
            {edit ? "Edit Role" : "Add Role"}
          </p>

          <div className="mt-10 px-80">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-16">
              <div>
                <label className="primary-label">Name</label>
                <input
                  name="name"
                  value={data.name}
                  onChange={(e) => handleChange(e)}
                  placeholder="Name"
                  className="primary-input"
                />
              </div>
            </div>
            <div className="flex items-center justify-center mt-12">
              <SecondaryButton
                text={loading ? "Adding..." : edit ? "Edit" : "Add"}
                Icon={FiPlus}
                color="!px-16"
                onClick={() => submit()}
              />
            </div>
          </div>
        </main>
      )}
    </>
  );
};

export default AddRole;
